var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Prop, Component, Mixins } from 'vue-property-decorator';
import ValidatedFieldMixin from '@/mixins/validated-field-mixin';
import { getPropertyFromItem } from 'vuetify/es5/util/helpers.js';
var ValidatedAutocomplete = /** @class */ (function (_super) {
    __extends(ValidatedAutocomplete, _super);
    function ValidatedAutocomplete() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(ValidatedAutocomplete.prototype, "allItemsSelected", {
        get: function () {
            return this.innerValue ? this.innerValue.length === this.items.length : false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ValidatedAutocomplete.prototype, "someItemsSelected", {
        get: function () {
            return this.innerValue ? this.innerValue.length > 0 && !this.allItemsSelected : false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ValidatedAutocomplete.prototype, "selectAllIcon", {
        get: function () {
            if (this.allItemsSelected) {
                return 'check_box';
            }
            if (this.someItemsSelected) {
                return 'indeterminate_check_box';
            }
            return 'check_box_outline_blank';
        },
        enumerable: false,
        configurable: true
    });
    ValidatedAutocomplete.prototype.getText = function (item) {
        return getPropertyFromItem(item, this.itemText, item);
    };
    ValidatedAutocomplete.prototype.getValue = function (item) {
        return getPropertyFromItem(item, this.itemValue, this.getText(item));
    };
    ValidatedAutocomplete.prototype.toggleAll = function () {
        var _this = this;
        this.$nextTick(function () {
            _this.innerValue = _this.allItemsSelected
                ? []
                : _this.items.slice().map(function (item) { return _this.getValue(item); });
        });
    };
    ValidatedAutocomplete.prototype.onChanged = function (val) {
        this.$emit('changed', val);
    };
    __decorate([
        Prop({ type: Array, required: false, default: function () { return []; } }),
        __metadata("design:type", Object)
    ], ValidatedAutocomplete.prototype, "items", void 0);
    __decorate([
        Prop({ type: [String, Array, Function], required: false, default: 'text' }),
        __metadata("design:type", Object)
    ], ValidatedAutocomplete.prototype, "itemText", void 0);
    __decorate([
        Prop({ type: [String, Array, Function], required: false, default: 'value' }),
        __metadata("design:type", Object)
    ], ValidatedAutocomplete.prototype, "itemValue", void 0);
    __decorate([
        Prop({ type: Boolean, required: false, default: false }),
        __metadata("design:type", Boolean)
    ], ValidatedAutocomplete.prototype, "multiple", void 0);
    __decorate([
        Prop({ type: Boolean, required: false, default: true }),
        __metadata("design:type", Boolean)
    ], ValidatedAutocomplete.prototype, "clearable", void 0);
    __decorate([
        Prop({ type: Boolean, required: false, default: false }),
        __metadata("design:type", Boolean)
    ], ValidatedAutocomplete.prototype, "selectAll", void 0);
    ValidatedAutocomplete = __decorate([
        Component({})
    ], ValidatedAutocomplete);
    return ValidatedAutocomplete;
}(Mixins(ValidatedFieldMixin)));
export default ValidatedAutocomplete;
